import React from 'react';
import { Hero } from '../components/sections/Hero';
import { TrustBar } from '../components/sections/TrustBar';
import { AboutDestaMeet } from '../components/sections/AboutDestaMeet';
import { WhatWeDoForYou } from '../components/sections/WhatWeDoForYou';
import { WhyDestaMeet } from '../components/sections/WhyDestaMeet';
import { RoiStats } from '../components/sections/RoiStats';
import { ProcessTimeline } from '../components/sections/ProcessTimeline';
import { SocialProof } from '../components/sections/SocialProof';
import { CtaSection } from '../components/sections/CtaSection';
export function Home() {
  return <>
      <Hero data-id="element-2314" />
      <TrustBar data-id="element-2315" />
      <AboutDestaMeet data-id="element-2316" />
      <WhatWeDoForYou data-id="element-2317" />
      <WhyDestaMeet data-id="element-2318" />
      <RoiStats data-id="element-2319" />
      <ProcessTimeline data-id="element-2320" />
      <SocialProof data-id="element-2321" />
      <CtaSection data-id="element-2322" />
    </>;
}